import {getSetting} from '@woocommerce/settings';
import {registerPaymentMethod, registerExpressPaymentMethod} from '@woocommerce/blocks-registry';
import {loadPayPalSdk} from "@ppcp/utils";
import ApplePay from './ApplePay';
import {PaymentMethodLabel} from "../../components";
import ApplePayPreview from "./ApplePayPreview";
import {isCartPage, isAdminOnly} from "../../utils";

const data = getSetting('ppcp_applepay_data');
const queryParams = getSetting('paypalQueryParams');

let cachedCanMakePayment = null;

const canMakePayment = async ({cart}) => {
    const {cartTotals} = cart;

    if (isAdminOnly()) {
        return false;
    }
    // Return cached result if available
    if (cachedCanMakePayment !== null) {
        return cachedCanMakePayment;
    }
    if (!window.ApplePaySession) {
        return false;
    }
    if (cartTotals.currency_code) {
        if (!data.supportedCurrencies.includes(cartTotals.currency_code)) {
            return false;
        }
    }

    // Load PayPal SDK
    const paypal = await loadPayPalSdk(queryParams);

    if (!paypal?.Applepay) {
        cachedCanMakePayment = false;
        return false;
    }
    if (!ApplePaySession.canMakePayments()) {
        return false;
    }
    const config = await paypal.Applepay().config();

    cachedCanMakePayment = config.isEligible;

    return cachedCanMakePayment;
}

registerPaymentMethod({
    name: 'ppcp_applepay',
    gatewayId: 'ppcp_applepay',
    paymentMethodId: 'ppcp_applepay',
    canMakePayment: async (props) => {
        // Check if Apple Pay is enabled for block payment method
        if (!data.sections.includes('checkout')) {
            return false;
        }

        // Check if Google Pay is available on this browser/device
        return await canMakePayment(props);
    },
    content: <ApplePay name={'ppcp_applepay'} paymentMethodId={'ppcp_applepay'} data={data}/>,
    edit: <ApplePayPreview
        src={data.editorIcons.long}
        settings={data.button}/>,
    ariaLabel: 'Apple Pay',
    label: <PaymentMethodLabel id={'ppcp_applepay'} title={data.title} icons={data.icons}/>,
    supports: {
        showSavedCards: true,
        showSaveOption: false,
        features: data.features
    }
});

registerExpressPaymentMethod({
    name: 'ppcp_applepay_express',
    gatewayId: 'ppcp_applepay',
    paymentMethodId: 'ppcp_applepay',
    canMakePayment: async (props) => {
        const section = isCartPage() ? 'cart' : 'express_checkout';

        if (!data.sections.includes(section)) {
            return false;
        }

        // Check if Google Pay is available on this browser/device
        return await canMakePayment(props);
    },
    content: <ApplePay name={'ppcp_applepay_express'} paymentMethodId={'ppcp_applepay'} data={data} isExpress={true}/>,
    edit: <ApplePayPreview
        icons={data.editorIcons}
        settings={data.button}/>,
    supports: {
        showSavedCards: true,
        showSaveOption: false,
        features: data.features
    }
});